var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "modal-dialog go-modal-goover-create channel reg",
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-title",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleClose.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-24 go-icon-arrow-left",
                        }),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(_vm.$t("cdHome.t158")))]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon close",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleClose.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "go-tooltip-area",
                            attrs: { "data-toggle": "tooltip", title: "Close" },
                          },
                          [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "ul",
                      { staticClass: "nav go-tab-pills" },
                      [
                        _vm._l(_vm.categoryType, function (item, index) {
                          return [
                            _c(
                              "li",
                              {
                                key: index,
                                staticClass: "go-tab-item",
                                staticStyle: { "margin-bottom": "10px" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleChangeCategoryType(
                                      item.name
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "go-tab-link",
                                    class: {
                                      active: item.name === _vm.channelByType,
                                    },
                                    attrs: {
                                      "data-toggle": "tab",
                                      "data-target": "#go-search-all",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.label) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "scrap-step-wrap" }, [
                      _vm.loadingRegisterChannel
                        ? _c("div", { staticClass: "go-loading" }, [
                            _c("div", { staticClass: "go-icon-wrap" }, [
                              _c("i", {
                                staticClass:
                                  "go-icon-54 go-spinner custom-go-spinner",
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "go-modal-inner overflow-y-scroll" },
                        [
                          _c(
                            "vue-custom-scrollbar",
                            {
                              staticClass:
                                "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyReport",
                              attrs: { settings: _vm.scrollSettings },
                            },
                            [
                              _c("div", { staticClass: "go-section-body" }, [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "go-card-sub-list go-card-channel",
                                  },
                                  [
                                    _vm.channelByType == "URL" ||
                                    _vm.channelByType == "RSS"
                                      ? _c(
                                          "li",
                                          {
                                            staticClass: "go-list-item",
                                            attrs: { "aria-selected": "false" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-card-sub btn-register",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "go-card-body",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-register",
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleShowUrlForm.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-plus",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.$t(
                                                                "scrap-agent.register-table.url-rss-register-title",
                                                                {
                                                                  channelByType:
                                                                    _vm.channelByType,
                                                                }
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("dfn", [
                                                          _vm._v(
                                                            "\n                              " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "scrap-agent.register-table.url-rss-register-des"
                                                                )
                                                              ) +
                                                              "\n                            "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.listChannels, function (item) {
                                      return [
                                        _c(
                                          "li",
                                          {
                                            key: item.channelType,
                                            staticClass: "go-list-item",
                                            attrs: { "aria-selected": "false" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "go-card-sub",
                                                class: {
                                                  "acc-connect":
                                                    item.numberRegister > 0 ||
                                                    (item.accounts &&
                                                      item.accounts.length > 0),
                                                },
                                              },
                                              [
                                                _c("scrap-agent-card", {
                                                  attrs: {
                                                    data: {
                                                      cardId: item.channelId,
                                                      imageUri:
                                                        item.channelImageUri,
                                                      title: item.channelName,
                                                      description:
                                                        item.channelDescription,
                                                      numberRegister:
                                                        item.accounts.length,
                                                    },
                                                  },
                                                  on: {
                                                    handleConnect: function (
                                                      $event
                                                    ) {
                                                      return _vm.handleConnect(
                                                        item
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default go-btn-lg",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleClose.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("scrap-agent.cancel")))]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }